import * as Yup from "yup";
import cn from "classnames";

import styles from "./AscHelpMessageModal.module.scss";
import AscModal, { AscModalProps } from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";
import AscTextTextArea from "../AscInputFields/AscTextArea/AscTextArea";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import { useFormik } from "formik";

export interface AscHelpMessageModalProps
  extends Omit<AscModalProps, "children"> {
  className?: string;
  onSend: (message: string, cb: () => void) => void;
  onCancel: () => void;
  loading?: boolean;
}

export default function AscHelpMessageModal({
  className,
  onSend,
  onCancel,
  ...rest
}: AscHelpMessageModalProps) {
  const formik = useFormik({
    initialValues: {
      message: "",
    },
    validationSchema: Yup.object({
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: (values) => {
      onSend(values.message, () => formik.setFieldValue("message", ""));
    },
  });

  function handleCancelClick() {
    formik.setFieldValue("message", "");
    onCancel();
  }

  return (
    <AscModal
      modalClassName={styles.ground}
      header="Write what bothers you"
      headerClassName={styles.header}
      innerContentClassName={styles.innerContent}
      testId="asc-help-message-modal"
      {...rest}
    >
      <AscParagraph className={styles.description}>
        We will send you an answer within 24 hours
      </AscParagraph>
      <form onSubmit={formik.handleSubmit}>
        <div className={styles.fieldWrapper}>
          <label htmlFor="message" className={styles.fieldLabel}>
            Message
          </label>
          <AscTextTextArea
            className={cn(styles.field, {
              [styles.error]: formik.errors.message && formik.touched.message,
            })}
            id="message"
            name="message"
            fullWidth={true}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.message}
            placeholder="Explain a problem in more detail"
          />
          {formik.errors.message && formik.touched.message && (
            <div className={styles.fieldError}>{formik.errors.message}</div>
          )}
        </div>
        <footer className={styles.footer}>
          <AscButton
            className={styles.footerButton}
            variant="secondary"
            size="large"
            onClick={handleCancelClick}
          >
            Cancel
          </AscButton>
          <AscButton
            type="submit"
            className={styles.footerButton}
            variant="primary"
            size="large"
          >
            Send
          </AscButton>
        </footer>
      </form>
    </AscModal>
  );
}
